// extracted by mini-css-extract-plugin
export default {"outer_navbar":"dropdown_outer_navbar__hTn60","navdrop":"dropdown_navdrop__B+MHV","seller_container":"dropdown_seller_container__K78B5","store_name":"dropdown_store_name__pfrLM"};